import { ref } from 'vue'

// Create singleton state
const shouldOpenReviewsTab = ref(false)
const reviewsTabElement = ref<HTMLElement | null>(null)

// Create a simple event system
const eventBus = {
  listeners: new Set<() => void>(),
  emit() {
    this.listeners.forEach(listener => listener())
  },
  on(listener: () => void) {
    this.listeners.add(listener)
  },
  off(listener: () => void) {
    this.listeners.delete(listener)
  }
}

export const useReviewsTab = () => {
  const openReviewsTab = () => {
    shouldOpenReviewsTab.value = true
    eventBus.emit()
    
    // Reset after a short delay to allow the component to react
    setTimeout(() => {
      shouldOpenReviewsTab.value = false
    }, 100)
  }

  const scrollToReviewsTab = () => {
    if (reviewsTabElement.value) {
      reviewsTabElement.value.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      })
    }
  }

  return {
    shouldOpenReviewsTab,
    reviewsTabElement,
    openReviewsTab,
    scrollToReviewsTab,
    eventBus
  }
} 